import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { CdnIcon } from '@shared/ui';
const Tip = ({ className, variant = 'included', title, rightIcon }) => {
    const { Tip: theme } = useTheme('Shared');
    return (React.createElement("span", { className: cn(theme.root, className, theme[variant]) },
        title,
        rightIcon && React.createElement(CdnIcon, { icon: rightIcon })));
};
export default Tip;
